import {Article} from '../../models/Article';


export class RenderArticle {

  constructor() { }
  public article : Article;

}
